import { Component, OnInit } from '@angular/core';
import { VersionConstant } from './version';
import { ClientAppConfig, AppConfigService } from '../app/services/appconfig.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  public config: ClientAppConfig;
  year: number;
  technicalSupportPhone: string;
  generalenquiriesPhone: string;

  constructor(appConfigService: AppConfigService) {
    const date = new Date();
    this.year = date.getFullYear();


    // knp todo Refactor to follow the safescript common pattern and use
    // initialiser
    appConfigService.init(VersionConstant.APP_VERSION);
    appConfigService.getConfiguration().subscribe(config => {
      this.config = config;
      if (this.config) {
        if (this.config.technicalSupportPhone) {
          this.technicalSupportPhone = this.config.technicalSupportPhone;
        }
        if (this.config.generalenquiriesPhone) {
          this.generalenquiriesPhone = this.config.generalenquiriesPhone;
        }
      }
    });
  }

  ngOnInit() { }

  registrationLogin() {
    if (this.config && this.config.registrationUrl) {
      window.open(this.config.registrationUrl);
    }
  }

  prescriberTraining() {
    if (this.config && this.config.prescriberTraining) {
      window.open(this.config.prescriberTraining);
    }
  }

  PharmacistTraining() {
    if (this.config && this.config.pharmacistTraining) {
      window.open(this.config.pharmacistTraining);
    }
  }


  hpLogin() {
    if (this.config && this.config.hpUrl) {
      window.open(this.config.hpUrl);
    }
  }

  qscriptWebsite() {
    if (this.config && this.config.safescriptInfo) {
      window.open(this.config.safescriptInfo);
    }
  }
  patientInfo() {
    if (this.config && this.config.patientUrl) {
      window.open(this.config.patientUrl);
    }
  }
  generalEnquirie() {
    window.open('mailto:safescript@dhhs.vic.gov.au', '_self');
  }
  technicalSupport() {
    window.open('mailto:it.safescript@dhhs.vic.gov.au', '_self');
  }
  home() {
    if (this.config && this.config.safescriptInfo) {
      window.open(this.config.safescriptInfo);
    }
  }
  support() {
    if (this.config && this.config.supportUrl) {
      window.open(this.config.supportUrl);
    }
  }
  accessibility() {
    if (this.config && this.config.accessibilityUrl) {
      window.open(this.config.accessibilityUrl);
    }
  }
  copyright() {
    if (this.config && this.config.copyrightUrl) {
      window.open(this.config.copyrightUrl);
    }
  }
  disclaimer() {
    if (this.config && this.config.disclaimerUrl) {
      window.open(this.config.disclaimerUrl);
    }
  }
  privacy() {
    if (this.config && this.config.privacyUrl) {
      window.open(this.config.privacyUrl);
    }
  }
  twitter() {
    if (this.config && this.config.twitter) {
      window.open(this.config.twitter);
    }
  }
}
